import React from 'react'
import { useIntl } from 'react-intl'
import { useRecoilState } from 'recoil'

import { senderInfoState } from 'Pages/EmailSendingWizard/recoil/state/senderInfo'
import {
  FormElement,
  FORM_ELEMENT_SPACING_SMALL,
  InputText
} from 'mailup-web-components'
import { evalCondition } from 'mailup-react-helpers'

const InputSenderName = () => {
  const intl = useIntl()
  const [{ senderName, customSender }, setSenderInfo] = useRecoilState(
    senderInfoState
  )

  const handleChangeName = e => {
    setSenderInfo(prev => ({
      ...prev,
      senderName: e.target.value,
      savedAsDefault: undefined
    }))
  }

  return (
    <>
      <FormElement
        required
        label={
          customSender
            ? intl.formatMessage({
                id: 'Load.EmailSendingWizard.DefaultSenderNameLabel'
              })
            : intl.formatMessage({ id: 'Load.Common.SenderNameLabel' })
        }
        labelHelp={
          customSender
            ? intl.formatMessage({
                id: 'Load.EmailSendingWizard.SenderNameDefaultTooltip'
              })
            : undefined
        }
        labelSpacing={FORM_ELEMENT_SPACING_SMALL}
        feedback={
          senderName === ''
            ? intl.formatMessage({
                id: 'Load.EmailSendingWizard.SenderNameRequired'
              })
            : undefined
        }
        feedbackVariant={senderName === '' ? 'danger' : undefined}
      >
        <InputText
          placeholder={senderName}
          value={senderName}
          onChange={handleChangeName}
          disabled={evalCondition('uo:EMAILSENDERLOCKED')}
          variant={senderName === '' ? 'danger' : null}
          data-mu-test='sending-wizard-input-sender-name'
        />
      </FormElement>
    </>
  )
}

export default InputSenderName
